import { Page, PanelContainer } from '../../page-framework';
import NoAccessPanel from '../../panels/no-access-panel/NoAccessPanel';

export const pageId = 'no-access';

export default function NoAccessPage() {
    return (
        <Page id={pageId}>
            <PanelContainer>
                <NoAccessPanel />
            </PanelContainer>
        </Page>
    );
}
